import React, { Component } from "react";

// Components
import SvgIcon from "./SvgIcon";

// CSS
import "../../css/document-list.css";

class DocumentList extends Component {
	render() {
		return (
			<div className="document-list">
				<h3>{!!this.props.title ? this.props.title : "Documents"}</h3>

				{this.props.documents.map(doc => (
					<a key={doc.id} href={doc.url} target="_blank" rel="noopener noreferrer">
						<SvgIcon type={doc.type} />
						<span className="doc-title">{doc.title}</span>
					</a>
				))}
			</div>
		);
	}
}

export default DocumentList;



// WEBPACK FOOTER //
// ./src/components/utils/DocumentList.js